import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import apiClient from '../../lib/apiClient';
import { IAppointment } from '../../constants/types';

interface AppointmentResponse {
  data: {
    appointment: IAppointment | null;
  };
}

const fetchAppointment = async (id: string): Promise<IAppointment | null> => {
  if (!id) return null;

  const response: AxiosResponse<AppointmentResponse> = await apiClient.get(
    `/appointments/${id}`,
    {
      params: {
        order_direction: 'asc',
        order_by: 'date',
      },
    }
  );

  return response?.data?.data?.appointment ?? null;
};

const useFetchAppointmentDetails = (id: string) => {
  return useQuery<IAppointment | null>({
    queryKey: ['appointment', id],
    queryFn: () => fetchAppointment(id),
    enabled: !!id,
  });
};

export default useFetchAppointmentDetails;
